import { useEffect, useState } from "react";
import { offerCatalog } from "./offerCatalog";
import { trackCheckoutStart } from "../../utils/tracking";

export const CHECKOUT_ENDPOINT =
  "https://createcheckoutsession-5xcspkpkvq-uc.a.run.app";

const checkoutErrorMessage =
  "Betaling starten lukt niet. Probeer het opnieuw of neem contact op.";

const getCheckoutTrackingPayload = (productKey) => {
  const offer = offerCatalog.find((item) => item.productKey === productKey);
  const priceMatch = offer?.priceLabel?.match(/\d+/);
  const price = priceMatch ? Number(priceMatch[0]) : null;

  return {
    productType: productKey,
    productName: offer?.title || productKey,
    price: Number.isFinite(price) ? price : null,
    currency: "EUR",
    source: "pricing",
  };
};

const useCheckoutSession = () => {
  const [loadingProductKey, setLoadingProductKey] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const resetCheckoutLoading = (event) => {
      if (event.persisted) {
        setLoadingProductKey("");
      }
    };

    window.addEventListener("pageshow", resetCheckoutLoading);
    return () => {
      window.removeEventListener("pageshow", resetCheckoutLoading);
    };
  }, []);

  const startCheckout = async (productKey) => {
    if (loadingProductKey) return;

    setLoadingProductKey(productKey);
    setError("");

    try {
      const response = await fetch(CHECKOUT_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ productKey }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.url) {
        throw new Error("Checkout session creation failed");
      }

      trackCheckoutStart(getCheckoutTrackingPayload(productKey));
      window.location.assign(data.url);
    } catch {
      setError(checkoutErrorMessage);
      setLoadingProductKey("");
    }
  };

  return {
    startCheckout,
    loading: Boolean(loadingProductKey),
    loadingProductKey,
    error,
  };
};

export default useCheckoutSession;
